// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow/Barlow-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow/Barlow-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Barlow/Barlow-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Sari/LLSrMdCE.TTF", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/background.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Barlow-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: 'Barlow-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: 'Barlow-Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: 'Sari';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
}

:root {
--color5: #CC071E;
--color4: #D6394B;
--color3: #E06A78;
--color2: #F2C1C7;
--color1: #FAE6E8;

--grey5: #2A2E38;
--grey4: #555A64;
--grey3: #82868F;
--grey2: #ACB1B8;
--grey1: #EAEBEB;

--white: #ffffff;
}


body {
  max-width: 1080px;
  max-height: 1920px;
  background-color: var(--white);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  margin: auto;
  position: absolute;
  flex-direction: column;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.app-layout {
  max-width: 1080px;
  max-height: 1920px;
  background-color: var(--white);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;
  margin: auto;
  position: absolute;
  flex-direction: column;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

header {
  flex:1 1;
  display: flex;
  flex-direction: column;
  margin-inline: 11% ;
}

h1 {
  font-family: 'Sari';
  font-style: normal;
  font-weight: 700;
  font-size: 80px;
  line-height: 96px;
  text-align: center;
  text-transform: capitalize;
  color: var(--color5);
  align-self: center;
  margin-block:0;
  margin-top:160px;
}

h2 {
  font-family: 'Barlow-Bold';
  font-style: normal;
  font-size: 56px;
  line-height: 67px;
  text-align: center;
  color: var(--grey5);
  align-self: center;
  margin-block: 32px;
}

.content {
  display: flex;
  flex-direction: column;
  flex:3.7 1
}

.container {
  margin-inline: 11%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.loading {
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
}

.image {
  width: 100%;
  position: relative;
}

.logo {
  width: 100%;
}

.logo-home {
  width: 60%;
  padding-block: 50px;
  align-self: center;
  display: flex;
}

a {
  text-decoration: none;
}

html {
-webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*pode ser transparent também*/
}

.bottom {
  position: absolute;
  bottom: 100px;
  left:50%;
  transform: translateX(-50%);
}


.logo {
  width: 100%
}

custom {
  font-family: 'Sari';
  font-size: 56px;
  font-weight: 700;
  line-height: 76px;
  letter-spacing: 0em;
  text-align: center;

  color: var(--grey5);
}

.image {
  display: flex;
  justify-content: center;
}

.language {
  display: flex;
  flex-direction: column;
  flex:5 1;
  margin-block:100px;
}
.button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 40px 100px;
  gap: 43px;

  background: var(--grey5);
  border-radius: 80px;
  border-width: 0px;
  width: 100%;
  margin-block:60px;
}

.button:active {
  background: var(--color5);
}

.button-text {
  font-family: 'Sari';
  font-style: normal;
  font-weight: 500;
  font-size: 56px;
  line-height: 67px;

  text-align: center;
  text-transform: capitalize;

  color: var(--white);
}

.payments {
  display: flex;
  justify-content: center;
  gap: 32px;
  filter: drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.1));
}

#myProgress {
width: 100%;
background-color: var(--color2);
position: relative;
border-radius: 80px;
overflow: hidden;
}

#myBar {
width: 1%;
background-color: var(--color5);
padding-block: 40px;
height: 10px;
border-radius: 80px;
}

#myProgress:active #myBar{
  background: var(--grey5);
}

#myProgress:active{
  background: var(--grey5);
}

#text-progress {
  font-family: 'Barlow-Regular';
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 58px;
  text-align: center;

  text-transform: capitalize;

  color: var(--grey5);

  position: absolute;
  left: 0;
  right: 0;
  margin: auto;

  top:50%;
  transform: translateY(-50%);

}

#lockCircle {
  background-color: var(--color5);
  right: 8px;
  position: absolute;
  height: 72px;
  width: 72px;

  border-radius: 80px;

  top:50%;
  transform: translateY(-50%);
}

#lockCircle img{
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;

  top:50%;
  transform: translateY(-50%);
}


#myProgress {
  width: 100%;
  background-color: var(--color5);
  margin-block:80px;
  position: relative;
  border-radius: 80px;
  overflow: hidden;
}

#myBar {
  width: 1%;
  background-color: var(--color3);
  padding-block: 40px;
  height: 67px;
}

#myProgress:active #myBar{
    background: var(--grey5);
}

#myProgress:active{
    background: var(--grey5);
}

#text-progress {
    font-family: 'Sari';
    font-style: normal;
    font-weight: 700;
    font-size: 56px;
    line-height: 67px;
    text-align: center;

    text-transform: capitalize;

    color: var(--white);

    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

    top:50%;
    transform: translateY(-50%);

}

.confirm-label {
    background: #FFFFFF;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 24px;
    margin-inline: 11% ;
    width: 70%;
    padding: 40px 36px;
    position: absolute;
    bottom:0;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.purchase-text {
    font-family: 'Barlow-Medium';
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 58px;
    /* identical to box height */

    text-transform: capitalize;
    align-self: center;

    /* Grey 5 */

    color: var(--grey5);
}

.purchase-price {
    font-family: 'Barlow-Bold';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 77px;
    /* identical to box height */

    text-transform: capitalize;
    align-self: center;

    /* Grey 5 */

    color: var(--grey5);
}



`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,4CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,4CAA8C;AAChD;;AAEA;EACE,4BAA4B;EAC5B,4CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;AACA,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;;AAEjB,gBAAgB;AAChB,gBAAgB;AAChB,gBAAgB;AAChB,gBAAgB;AAChB,gBAAgB;;AAEhB,gBAAgB;AAChB;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,yDAAiD;EACjD,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,yDAAiD;EACjD,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAM;EACN,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;AACA,6CAA6C,EAAE,8BAA8B;AAC7E;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;AAC7B;;;AAGA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAM;EACN,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;;EAET,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;EAClB,0BAA0B;;EAE1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oDAAoD;AACtD;;AAEA;AACA,WAAW;AACX,+BAA+B;AAC/B,kBAAkB;AAClB,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA;AACA,SAAS;AACT,+BAA+B;AAC/B,mBAAmB;AACnB,YAAY;AACZ,mBAAmB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;;EAElB,0BAA0B;;EAE1B,mBAAmB;;EAEnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;;EAEZ,OAAO;EACP,2BAA2B;;AAE7B;;AAEA;EACE,+BAA+B;EAC/B,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,WAAW;;EAEX,mBAAmB;;EAEnB,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;;EAEZ,OAAO;EACP,2BAA2B;AAC7B;;;AAGA;EACE,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;IAElB,0BAA0B;;IAE1B,mBAAmB;;IAEnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;;IAEZ,OAAO;IACP,2BAA2B;;AAE/B;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,0BAA0B;IAC1B,kBAAkB;;IAElB,WAAW;;IAEX,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;IAE5B,0BAA0B;IAC1B,kBAAkB;;IAElB,WAAW;;IAEX,mBAAmB;AACvB","sourcesContent":["@font-face {\n  font-family: 'Barlow-Bold';\n  src: url(\"../fonts/Barlow/Barlow-Bold.ttf\");\n}\n\n@font-face {\n  font-family: 'Barlow-Regular';\n  src: url(\"../fonts/Barlow/Barlow-Regular.ttf\");\n}\n\n@font-face {\n  font-family: 'Barlow-Medium';\n  src: url(\"../fonts/Barlow/Barlow-Medium.ttf\");\n}\n\n@font-face {\n  font-family: 'Sari';\n  src: url(\"../fonts/Sari/LLSrMdCE.TTF\")\n}\n\n:root {\n--color5: #CC071E;\n--color4: #D6394B;\n--color3: #E06A78;\n--color2: #F2C1C7;\n--color1: #FAE6E8;\n\n--grey5: #2A2E38;\n--grey4: #555A64;\n--grey3: #82868F;\n--grey2: #ACB1B8;\n--grey1: #EAEBEB;\n\n--white: #ffffff;\n}\n\n\nbody {\n  max-width: 1080px;\n  max-height: 1920px;\n  background-color: var(--white);\n  background-image: url(\"../images/background.svg\");\n  box-shadow: 0 0 60px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  position: absolute;\n  flex-direction: column;\n  display: flex;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.app-layout {\n  max-width: 1080px;\n  max-height: 1920px;\n  background-color: var(--white);\n  background-image: url(\"../images/background.svg\");\n  box-shadow: 0 0 60px rgba(0, 0, 0, 0.2);\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  position: absolute;\n  flex-direction: column;\n  display: flex;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\nheader {\n  flex:1;\n  display: flex;\n  flex-direction: column;\n  margin-inline: 11% ;\n}\n\nh1 {\n  font-family: 'Sari';\n  font-style: normal;\n  font-weight: 700;\n  font-size: 80px;\n  line-height: 96px;\n  text-align: center;\n  text-transform: capitalize;\n  color: var(--color5);\n  align-self: center;\n  margin-block:0;\n  margin-top:160px;\n}\n\nh2 {\n  font-family: 'Barlow-Bold';\n  font-style: normal;\n  font-size: 56px;\n  line-height: 67px;\n  text-align: center;\n  color: var(--grey5);\n  align-self: center;\n  margin-block: 32px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  flex:3.7\n}\n\n.container {\n  margin-inline: 11%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.loading {\n  position: absolute;\n  top:50%;\n  left:50%;\n  transform: translate(-50%,-50%);\n}\n\n.image {\n  width: 100%;\n  position: relative;\n}\n\n.logo {\n  width: 100%;\n}\n\n.logo-home {\n  width: 60%;\n  padding-block: 50px;\n  align-self: center;\n  display: flex;\n}\n\na {\n  text-decoration: none;\n}\n\nhtml {\n-webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*pode ser transparent também*/\n}\n\n.bottom {\n  position: absolute;\n  bottom: 100px;\n  left:50%;\n  transform: translateX(-50%);\n}\n\n\n.logo {\n  width: 100%\n}\n\ncustom {\n  font-family: 'Sari';\n  font-size: 56px;\n  font-weight: 700;\n  line-height: 76px;\n  letter-spacing: 0em;\n  text-align: center;\n\n  color: var(--grey5);\n}\n\n.image {\n  display: flex;\n  justify-content: center;\n}\n\n.language {\n  display: flex;\n  flex-direction: column;\n  flex:5;\n  margin-block:100px;\n}\n.button {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 40px 100px;\n  gap: 43px;\n\n  background: var(--grey5);\n  border-radius: 80px;\n  border-width: 0px;\n  width: 100%;\n  margin-block:60px;\n}\n\n.button:active {\n  background: var(--color5);\n}\n\n.button-text {\n  font-family: 'Sari';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 56px;\n  line-height: 67px;\n\n  text-align: center;\n  text-transform: capitalize;\n\n  color: var(--white);\n}\n\n.payments {\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n  filter: drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.1));\n}\n\n#myProgress {\nwidth: 100%;\nbackground-color: var(--color2);\nposition: relative;\nborder-radius: 80px;\noverflow: hidden;\n}\n\n#myBar {\nwidth: 1%;\nbackground-color: var(--color5);\npadding-block: 40px;\nheight: 10px;\nborder-radius: 80px;\n}\n\n#myProgress:active #myBar{\n  background: var(--grey5);\n}\n\n#myProgress:active{\n  background: var(--grey5);\n}\n\n#text-progress {\n  font-family: 'Barlow-Regular';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 48px;\n  line-height: 58px;\n  text-align: center;\n\n  text-transform: capitalize;\n\n  color: var(--grey5);\n\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n\n  top:50%;\n  transform: translateY(-50%);\n\n}\n\n#lockCircle {\n  background-color: var(--color5);\n  right: 8px;\n  position: absolute;\n  height: 72px;\n  width: 72px;\n\n  border-radius: 80px;\n\n  top:50%;\n  transform: translateY(-50%);\n}\n\n#lockCircle img{\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n\n  top:50%;\n  transform: translateY(-50%);\n}\n\n\n#myProgress {\n  width: 100%;\n  background-color: var(--color5);\n  margin-block:80px;\n  position: relative;\n  border-radius: 80px;\n  overflow: hidden;\n}\n\n#myBar {\n  width: 1%;\n  background-color: var(--color3);\n  padding-block: 40px;\n  height: 67px;\n}\n\n#myProgress:active #myBar{\n    background: var(--grey5);\n}\n\n#myProgress:active{\n    background: var(--grey5);\n}\n\n#text-progress {\n    font-family: 'Sari';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 56px;\n    line-height: 67px;\n    text-align: center;\n\n    text-transform: capitalize;\n\n    color: var(--white);\n\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: auto;\n\n    top:50%;\n    transform: translateY(-50%);\n\n}\n\n.confirm-label {\n    background: #FFFFFF;\n    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);\n    border-radius: 24px;\n    margin-inline: 11% ;\n    width: 70%;\n    padding: 40px 36px;\n    position: absolute;\n    bottom:0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.purchase-text {\n    font-family: 'Barlow-Medium';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 48px;\n    line-height: 58px;\n    /* identical to box height */\n\n    text-transform: capitalize;\n    align-self: center;\n\n    /* Grey 5 */\n\n    color: var(--grey5);\n}\n\n.purchase-price {\n    font-family: 'Barlow-Bold';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 64px;\n    line-height: 77px;\n    /* identical to box height */\n\n    text-transform: capitalize;\n    align-self: center;\n\n    /* Grey 5 */\n\n    color: var(--grey5);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
